import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { createContext, useEffect, useContext, useReducer } from 'react';
import { initGTM, sendToGTM } from './utils/GoogleTagManager';
/**
 * The initial state
 */

export var initialState = {
  dataLayer: undefined,
  dataLayerName: 'dataLayer',
  environment: undefined,
  nonce: undefined,
  id: '',
  injectScript: true
};
/**
 * The context
 */

export var GTMContext = createContext(initialState);
export var GTMContextDispatch = createContext(undefined);

function dataReducer(state, data) {
  sendToGTM({
    data: data,
    dataLayerName: state === null || state === void 0 ? void 0 : state.dataLayerName
  });
  return state;
}
/**
 * The Google Tag Manager Provider
 */


function GTMProvider(_ref) {
  var state = _ref.state,
      children = _ref.children;

  var _useReducer = useReducer(dataReducer, _objectSpread(_objectSpread({}, initialState), state)),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      store = _useReducer2[0],
      dispatch = _useReducer2[1];

  useEffect(function () {
    if (!state || state.injectScript == false) return;

    var mergedState = _objectSpread(_objectSpread({}, store), state);

    initGTM(mergedState);
  }, [JSON.stringify(state)]);
  return /*#__PURE__*/React.createElement(GTMContext.Provider, {
    value: store
  }, /*#__PURE__*/React.createElement(GTMContextDispatch.Provider, {
    value: dispatch
  }, children));
}

function useGTMDispatch() {
  var context = useContext(GTMContextDispatch);

  if (context === undefined) {
    throw new Error('dispatchGTMEvent must be used within a GTMProvider');
  }

  return context;
}

export { GTMProvider, useGTMDispatch, sendToGTM };